/**
 * Collapse an accidentally-doubled URL back to a single copy.
 *
 * The "Add link" modal can auto-fill the URL field on a page-level paste and
 * then receive a second paste into the focused input, producing `URL + URL`
 * with no separator (e.g. `https://x/a/https://x/a/`). This returns the single
 * URL for that exact-double case and leaves everything else untouched — in
 * particular legitimate URLs that embed another URL (Wayback Machine,
 * `google.com/url?q=…`, redirect wrappers) are NOT modified, because their two
 * halves differ.
 */
export function collapseDoubledUrl(raw: string): string {
  const url = raw.trim();
  const schemeRe = /https?:\/\//g;
  let m: RegExpExecArray | null;
  while ((m = schemeRe.exec(url)) !== null) {
    const i = m.index;
    if (i > 0 && url.slice(0, i) === url.slice(i)) {
      return url.slice(0, i);
    }
  }
  return url;
}
